var _style, _defs, _path, _ellipse, _ellipse2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntruceptLightLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 670 113.4",
    style: {
      enableBackground: "new 0 0 670 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000147920962480785417560000004148076653250628492_);}\r\n\t.st1{fill:url(#SVGID_00000159448525346774642520000009404494373988071079_);}\r\n\t.st2{fill:url(#SVGID_00000050624515393185778220000006225092808471745465_);}\r\n\t.st3{fill:#221F1F;}\r\n\t.st4{fill:url(#SVGID_00000032625023366244735780000010754166650500487351_);}\r\n\t.st5{fill:url(#SVGID_00000140724941901052742410000000626864910779144625_);}\r\n\t.st6{fill:url(#SVGID_00000060010565419096086600000010638646541901238458_);}\r\n\t.st7{fill:url(#SVGID_00000067229820647885384430000016063601075662785153_);}\r\n\t.st8{fill:url(#SVGID_00000034058593955151853140000010718778209097598131_);}\r\n\t.st9{fill:url(#SVGID_00000178893329464244409550000009004014080181079724_);}\r\n\t.st10{fill:#231F20;}\r\n\t.st11{fill:#89181B;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 113,
    y: 2.3,
    width: 36.8,
    height: 50.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096050402850461900430000011498741501173666698_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    style: {
      clipPath: "url(#SVGID_00000096050402850461900430000011498741501173666698_)"
    },
    d: "M194,25 c-10.2,2.2-20.7,1.6-31,3.4c-5.7,1-12,2.9-17.2,6.1c1.7-4.4,3-9,2.3-13.7c-0.8-5-4.1-9.5-8.5-11.7c-4.5-2.3-10-2.2-14.4,0.1l0,0.1 c-1.9,0.2-4.7,1.3-6.8,2.2c-1.9,0.8-3.2,2.6-3.3,4.7c0,0,0,0,0,0.1c-0.2,2.7,2.3,6.5,2.3,6.5l0.1-1.4c0.1-1.1,0.7-2.1,1.7-2.5 c1-0.5,2-0.8,3.1-0.9c0.9-0.1,1.8,0,2.6,0.3l-0.1,3.9c-2.1,5-6.1,9.1-10.9,11.6c-4.9-2.7-10.5-4.4-15.7-5.3 c-10.3-1.7-20.8-1.1-31-3.4C48,20.7,31.5,5.8,25.2-13c0.4,6.2,1.1,12.3,2.4,18.2c0.3,0.8,0.6,1.6,1.1,2.7 c1.6,3.6,4.2,8.3,7.6,12.5c3.4,4.2,7.6,7.8,11,10.3c1.7,1.2,3.2,2.2,4.2,2.8c1,0.7,1.6,1,1.6,1s-0.7-0.2-1.8-0.6 c-1.2-0.4-2.8-1-4.8-1.9c-3.7-1.6-8.6-4.2-13.1-7.6c1.1,2.6,2.3,5,3.6,7.5c0.3,0.4,0.6,0.7,1.1,1.2c2,2.2,5.1,4.8,8.5,7.1 c3.4,2.3,7.1,4.1,10.1,5.2c2.9,1.1,5,1.6,5,1.6s-2.1,0.1-5.4-0.1c-2.9-0.2-6.6-0.8-10.5-1.8c2.7,3.3,5.8,6.5,9.2,9.4 c0.3,0.1,0.6,0.2,0.8,0.3c3.6,1.2,7.5,1.8,10.5,1.8c3,0.1,5-0.2,5-0.2s-1.8,0.9-4.8,1.8c-1.5,0.5-3.4,0.9-5.5,1.2 c2.8,2,5.8,3.9,9,5.7c1.6,0.4,3.3,0.7,5.1,0.9c1.7,0.1,3.3,0.1,4.8-0.1c1.5-0.2,3-0.6,4.2-1.1c2.4-1,3.8-2.2,3.8-2.2 s-0.2,0.4-0.7,1c-0.5,0.6-1.2,1.5-2.3,2.5c-1.1,0.9-2.4,1.9-4,2.8c-0.5,0.3-1.1,0.5-1.7,0.8c0.8,0.4,1.6,0.7,2.4,1.1 c3.3,1.3,6.8,2.4,10.3,3.2c0.5-0.1,0.9-0.2,1.4-0.2c2.9-0.5,5.6-1.7,7.1-3.4c1.6-1.6,1.9-3.3,1.9-3.3s0,0.4,0,1.1 c-0.1,0.7-0.3,1.7-0.9,2.9c-0.3,0.6-0.6,1.1-1.1,1.7c-0.4,0.6-1,1.2-1.6,1.7c-0.2,0.2-0.4,0.3-0.5,0.4c8.4,0.6,16.8-1.2,24.2-6.9 c-0.9,3.1-4.7,7.2-16.1,11.2c15.9,1.5,24.2,20.9,24.2,20.9s8.3-19.5,24.2-20.9c-11.4-4-15.2-8.1-16.1-11.2 c7.4,5.7,15.8,7.5,24.2,6.9c-0.2-0.1-0.4-0.3-0.5-0.4c-0.5-0.5-1.1-1.1-1.6-1.7c-0.4-0.6-0.8-1.2-1.1-1.7 c-0.6-1.1-0.8-2.2-0.9-2.9c-0.1-0.7,0-1.1,0-1.1s0.3,1.7,1.9,3.3c1.5,1.7,4.2,2.9,7.1,3.4c0.5,0.1,0.9,0.2,1.4,0.2 c3.5-0.7,7-1.8,10.3-3.2c0.8-0.3,1.6-0.7,2.4-1.1c-0.6-0.3-1.2-0.5-1.7-0.8c-1.6-0.8-3-1.8-4-2.8c-1.1-0.9-1.8-1.8-2.3-2.5 c-0.5-0.6-0.7-1-0.7-1s1.4,1.2,3.8,2.2c1.2,0.5,2.6,0.9,4.2,1.1c1.6,0.2,3.2,0.3,4.8,0.1c1.7-0.1,3.5-0.5,5.1-0.9 c3.2-1.8,6.2-3.7,9-5.7c-2-0.3-3.9-0.7-5.5-1.2c-3-0.9-4.8-1.8-4.8-1.8s2,0.3,5,0.2c3,0,6.9-0.6,10.5-1.8c0.3-0.1,0.6-0.2,0.8-0.3 c3.4-3,6.4-6.1,9.2-9.4c-3.8,1-7.6,1.6-10.5,1.8c-3.2,0.2-5.4,0.1-5.4,0.1s2.1-0.5,5-1.6c3-1.1,6.7-2.9,10.1-5.2 c3.4-2.3,6.4-4.9,8.5-7.1c0.4-0.5,0.8-0.8,1.1-1.2c1.3-2.4,2.6-4.9,3.6-7.5c-4.5,3.5-9.4,6-13.1,7.6c-2,0.8-3.6,1.5-4.8,1.9 c-1.2,0.4-1.8,0.6-1.8,0.6s0.6-0.4,1.6-1c1.1-0.6,2.5-1.6,4.2-2.8c3.4-2.5,7.6-6.1,11-10.3c3.5-4.2,6.1-8.8,7.6-12.5 c0.5-1,0.8-1.9,1.1-2.7c1.2-5.9,2-12,2.4-18.2C229.8,5.8,213.2,20.7,194,25z M129.1,12.5c0,0-0.9-1.2-1.4-1.9 c2.9-2,5.8-0.4,5.8-0.4L129.1,12.5z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.5,27.8c-3.9,1.1-5.9,3.6-5.9,3.6L136.1,53l-6.5,6.8l-6.5-6.5l-18.5-21.7c0,0-2-2.5-5.9-3.6c-3.9-1.1-72.9-7-74.7-8 c0,0,3.6,10,6.4,13.8c2.9,4,8.3,6.7,14.8,7.8c0,0,13.8,1.1,20-1.4c0.1,0,0.2,0.1,0.1,0.2c-2.3,1.8-11.6,8.8-25.5,7.2 c0,0,4.5,5.9,12.4,12c1.5,1.1,4.4,0.4,8.1-1.3l11.1-5.5c0,0,2.5-1.7,0.3,1.2c-2.2,2.8-7.5,6.7-10.3,8.5c-0.6,0.4-1.4,2,1.4,2.9 c2.8,0.9,6.6,2.4,9.2,3.2c0.2,0.1,2.3,0.4,5-1.1c0,0,4.8-4.2,6.6-5.4c1.3-1,0.6,0.8-0.9,2.6l-3.5,4.7c0,0-0.8,0.9,1.1,0.9 c0,0,11.3,0.8,13.9,0.2c1-0.2,1.7-2,2.4-3.4c0.2-0.4,0.7-0.2,0.6,1.9c0,0-0.3,1.9,0.3,2.2c4.7,2.3,7.7,0.3,13.5,0.3 c0.5,0,2.6,0.6-0.3,1.4c-2.6,0.7-4.5,1.9-4.5,1.9s14.2,0.9,23.4,19.9c9.2-19,23.4-19.9,23.4-19.9s-1.9-1.2-4.5-1.9 c-2.9-0.8-0.8-1.4-0.3-1.4c5.8,0,8.8,2,13.5-0.3c0.6-0.3,0.3-2.2,0.3-2.2c-0.1-2.1,0.4-2.3,0.6-1.9c0.7,1.4,1.4,3.2,2.4,3.4 c2.6,0.6,13.9-0.2,13.9-0.2c1.9,0,1.1-0.9,1.1-0.9l-3.5-4.9c-1.5-1.8-2.2-3.6-0.9-2.6c1.8,1.2,6.6,5.4,6.6,5.4 c2.7,1.5,4.8,1.2,5,1.1c2.6-0.8,6.4-2.3,9.2-3.2s2-2.5,1.4-2.9c-2.8-1.8-8.1-5.7-10.3-8.5c-2.2-2.9,0.3-1.2,0.3-1.2l11.1,5.5 c3.7,1.7,6.6,2.4,8.1,1.3c7.9-6.1,12.4-12,12.4-12c-13.9,1.6-23.2-5.4-25.5-7.2c-0.1-0.1,0-0.2,0.1-0.2c6.2,2.5,20,1.4,20,1.4 c6.5-1.1,11.9-3.8,14.8-7.8c2.8-3.8,6.4-13.8,6.4-13.8C233.4,20.8,164.4,26.7,160.5,27.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073717459319111661040000006388329153984010162_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.095,
    y1: 50.6404,
    x2: 158.1345,
    y2: 55.7608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    style: {
      stopColor: "#86181B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4453,
    style: {
      stopColor: "#B92027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6911,
    style: {
      stopColor: "#D02228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E82429"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000073717459319111661040000006388329153984010162_)"
    },
    cx: 143.6,
    cy: 53.2,
    rx: 14.7,
    ry: 14.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150817409827261113180000011503363188134829969_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.245,
    y1: 59.3315,
    x2: 148.1716,
    y2: 46.4049
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A3A6A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000150817409827261113180000011503363188134829969_)"
    },
    cx: 141.7,
    cy: 52.9,
    rx: 9.2,
    ry: 9.1
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 140.4,
    cy: 50.6,
    rx: 7.5,
    ry: 7.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127730264836471967600000013138480621372635551_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.4849,
    y1: 44.3509,
    x2: 157.8287,
    y2: 44.3509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    style: {
      stopColor: "#86181B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4453,
    style: {
      stopColor: "#B92027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6911,
    style: {
      stopColor: "#D02228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E82429"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000127730264836471967600000013138480621372635551_)"
    },
    points: "129.5,37.7 157.8,28.9  129.5,59.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103243833445524077630000000830986199502523288_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.5878,
    y1: 49.386,
    x2: 101.1153,
    y2: 57.0152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    style: {
      stopColor: "#86181B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4453,
    style: {
      stopColor: "#B92027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6911,
    style: {
      stopColor: "#D02228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E82429"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000103243833445524077630000000830986199502523288_)"
    },
    cx: 115.4,
    cy: 53.2,
    rx: 14.7,
    ry: 14.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084524835252735659050000007616556878686905257_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.258,
    y1: 61.9533,
    x2: 117.258,
    y2: 43.7831
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A3A6A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000084524835252735659050000007616556878686905257_)"
    },
    cx: 117.3,
    cy: 52.9,
    rx: 9.2,
    ry: 9.1
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 118.5,
    cy: 50.6,
    rx: 7.5,
    ry: 7.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067926243328384320550000012701877941773280426_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.1376,
    y1: 44.3509,
    x2: 129.4814,
    y2: 44.3509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B92027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3996,
    style: {
      stopColor: "#D02228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9017,
    style: {
      stopColor: "#E82429"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000067926243328384320550000012701877941773280426_)"
    },
    points: "129.5,37.7 101.1,28.9  129.5,59.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108271513699497538970000002072191784036800898_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.4849,
    y1: 58.1898,
    x2: 136.5498,
    y2: 58.1898
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#848689"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D8DADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108271513699497538970000002072191784036800898_)"
    },
    d: "M129.5,48.8v18.7c0,0,7.1-4.9,7.1-9.8 S133.4,48.8,129.5,48.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106830848493448771190000004749093108942787727_",
    gradientUnits: "userSpaceOnUse",
    x1: 7044.5166,
    y1: 58.1898,
    x2: 7051.5815,
    y2: 58.1898,
    gradientTransform: "matrix(-1 0 0 1 7173.998 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A3A6A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106830848493448771190000004749093108942787727_)"
    },
    d: "M129.5,48.8v18.7c0,0-7.1-4.9-7.1-9.8 S125.6,48.8,129.5,48.8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M248.4,62.1V18.7h10v43.4H248.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M268.7,62.1V18.7h8.3l25.6,31.2h-4V18.7h9.9v43.4h-8.2l-25.7-31.2h4v31.2H268.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M327.8,62.1V26.9h-13.9v-8.2h37.8v8.2h-13.9v35.2H327.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M357.1,62.1V18.7h18.8c3.9,0,7.2,0.6,10,1.9c2.8,1.3,5,3.1,6.5,5.4s2.3,5.2,2.3,8.4c0,3.2-0.8,6-2.3,8.3 c-1.5,2.3-3.7,4.1-6.5,5.4c-2.8,1.2-6.2,1.9-10,1.9h-13.2l4.5-4.4v16.5H357.1z M367.2,46.7l-4.5-4.7h12.6c3.1,0,5.4-0.7,6.9-2 s2.3-3.2,2.3-5.5c0-2.4-0.8-4.3-2.3-5.6c-1.5-1.3-3.8-2-6.9-2h-12.6l4.5-4.8V46.7z M384.7,62.1l-10.8-15.7h10.7l11,15.7H384.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M422,62.8c-6.2,0-11-1.7-14.4-5.1c-3.5-3.4-5.2-8.3-5.2-14.7V18.7h10v23.9c0,4.1,0.8,7.1,2.5,8.9 c1.7,1.8,4.1,2.7,7.1,2.7c3.1,0,5.4-0.9,7.1-2.7c1.7-1.8,2.5-4.8,2.5-8.9V18.7h9.9V43c0,6.4-1.7,11.3-5.2,14.7 C432.9,61.1,428.1,62.8,422,62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M472.3,62.8c-3.3,0-6.5-0.5-9.3-1.6c-2.9-1.1-5.4-2.7-7.5-4.7c-2.1-2-3.8-4.4-4.9-7.1c-1.2-2.7-1.8-5.7-1.8-9 c0-3.3,0.6-6.3,1.8-9c1.2-2.7,2.8-5.1,5-7.1c2.1-2,4.6-3.6,7.5-4.7c2.9-1.1,6-1.6,9.4-1.6c3.8,0,7.2,0.7,10.2,2 c3,1.3,5.6,3.2,7.7,5.7l-6.4,6c-1.5-1.7-3.1-3-5-3.8c-1.8-0.8-3.8-1.3-6-1.3c-2,0-3.9,0.3-5.6,1c-1.7,0.7-3.2,1.6-4.4,2.9 s-2.2,2.7-2.9,4.4c-0.7,1.7-1,3.6-1,5.6c0,2.1,0.3,3.9,1,5.6c0.7,1.7,1.6,3.2,2.9,4.4s2.7,2.2,4.4,2.9c1.7,0.7,3.6,1,5.6,1 c2.1,0,4.1-0.4,6-1.3c1.8-0.8,3.5-2.1,5-3.9l6.4,6c-2.1,2.5-4.6,4.4-7.7,5.8S476.1,62.8,472.3,62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M507,54h23.6v8.1H497V18.7h32.8v8.1H507V54z M506.2,36.2h20.9V44h-20.9V36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M538.6,62.1V18.7h18.8c3.9,0,7.2,0.6,10,1.9s5,3.1,6.5,5.4c1.5,2.4,2.3,5.2,2.3,8.4c0,3.2-0.8,6-2.3,8.4 c-1.5,2.4-3.7,4.2-6.5,5.4c-2.8,1.3-6.2,1.9-10,1.9h-13.2l4.5-4.5v16.5H538.6z M548.6,46.7l-4.5-4.8h12.6c3.1,0,5.4-0.7,6.9-2 c1.5-1.3,2.3-3.2,2.3-5.5c0-2.4-0.8-4.3-2.3-5.6c-1.5-1.3-3.8-2-6.9-2h-12.6l4.5-4.8V46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M591.2,62.1V26.9h-13.9v-8.2h37.8v8.2h-13.9v35.2H591.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M248.8,99.1V76.5h2.4v22.6H248.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M266.7,82c1.4,0,2.6,0.3,3.6,0.8c1,0.5,1.9,1.3,2.5,2.4c0.6,1.1,0.9,2.4,0.9,4.1v9.8h-2.3v-9.6 c0-1.8-0.4-3.1-1.3-4c-0.9-0.9-2.1-1.4-3.8-1.4c-1.2,0-2.3,0.2-3.1,0.7c-0.9,0.5-1.6,1.2-2.1,2.1c-0.5,0.9-0.7,2-0.7,3.3v8.9H258 V82.2h2.2v4.6l-0.4-0.9c0.5-1.2,1.4-2.2,2.6-2.9C263.6,82.4,265.1,82,266.7,82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M277.2,84.1v-1.9h10.5v1.9H277.2z M285.2,99.3c-1.6,0-2.8-0.4-3.7-1.3c-0.9-0.9-1.3-2.1-1.3-3.6V78.4h2.3 v15.8c0,1,0.3,1.8,0.8,2.3c0.5,0.5,1.2,0.8,2.2,0.8c1,0,1.8-0.3,2.5-0.9l0.8,1.6c-0.5,0.4-1,0.7-1.6,0.9S285.9,99.3,285.2,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M292.9,99.1V82.2h2.2v4.6l-0.2-0.8c0.5-1.3,1.3-2.3,2.4-3c1.1-0.7,2.5-1,4.2-1v2.2c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.2,0-0.3,0c-1.8,0-3.2,0.5-4.2,1.6c-1,1.1-1.5,2.6-1.5,4.6v8.6H292.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M312.9,99.3c-1.4,0-2.7-0.3-3.8-0.8c-1.1-0.5-1.9-1.3-2.5-2.4c-0.6-1.1-0.9-2.4-0.9-4v-9.8h2.3v9.6 c0,1.8,0.4,3.2,1.3,4.1c0.9,0.9,2.1,1.4,3.8,1.4c1.2,0,2.2-0.2,3.1-0.7c0.9-0.5,1.5-1.2,2-2.1s0.7-2,0.7-3.3v-8.9h2.3v16.9H319 v-4.6l0.4,0.8c-0.5,1.2-1.4,2.2-2.5,2.9S314.4,99.3,312.9,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M332.1,99.3c-1.4,0-2.7-0.2-4-0.6c-1.2-0.4-2.2-0.9-2.9-1.5l1-1.8c0.7,0.5,1.6,1,2.6,1.3 c1.1,0.4,2.2,0.6,3.4,0.6c1.6,0,2.8-0.3,3.5-0.8c0.7-0.5,1.1-1.2,1.1-2c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.6-0.8 c-0.6-0.2-1.4-0.3-2.2-0.5c-0.8-0.1-1.6-0.3-2.4-0.5c-0.8-0.2-1.5-0.4-2.1-0.8c-0.6-0.3-1.2-0.8-1.6-1.4c-0.4-0.6-0.6-1.4-0.6-2.3 c0-0.9,0.3-1.8,0.8-2.5c0.5-0.7,1.3-1.3,2.3-1.7c1-0.4,2.2-0.6,3.7-0.6c1.1,0,2.2,0.1,3.3,0.4c1.1,0.3,2,0.7,2.7,1.1l-1,1.8 c-0.8-0.5-1.6-0.9-2.4-1.1c-0.9-0.2-1.7-0.3-2.6-0.3c-1.5,0-2.7,0.3-3.4,0.8c-0.7,0.5-1.1,1.2-1.1,2c0,0.6,0.2,1.2,0.6,1.5 c0.4,0.4,0.9,0.7,1.6,0.9c0.7,0.2,1.4,0.4,2.2,0.5c0.8,0.1,1.6,0.3,2.4,0.5c0.8,0.2,1.5,0.4,2.2,0.7s1.2,0.8,1.6,1.3 c0.4,0.6,0.6,1.3,0.6,2.2c0,1-0.3,1.8-0.8,2.6c-0.5,0.7-1.3,1.3-2.4,1.7C334.8,99.1,333.6,99.3,332.1,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M344.5,78.4c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.2c0-0.5,0.2-0.8,0.5-1.1c0.3-0.3,0.7-0.5,1.2-0.5 s0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.7,0.5,1.1c0,0.5-0.2,0.9-0.5,1.2C345.4,78.3,344.9,78.4,344.5,78.4z M343.3,99.1V82.2h2.3v16.9 H343.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M358.9,99.3c-1.6,0-3.1-0.4-4.4-1.1c-1.3-0.7-2.3-1.8-3.1-3.1c-0.8-1.3-1.1-2.8-1.1-4.5 c0-1.7,0.4-3.2,1.1-4.5c0.8-1.3,1.8-2.3,3.1-3c1.3-0.7,2.8-1.1,4.4-1.1c1.7,0,3.2,0.4,4.5,1.1c1.3,0.7,2.3,1.7,3.1,3 s1.1,2.8,1.1,4.5c0,1.7-0.4,3.2-1.1,4.5s-1.8,2.3-3.1,3.1C362,98.9,360.5,99.3,358.9,99.3z M358.9,97.2c1.2,0,2.3-0.3,3.3-0.8 c0.9-0.5,1.7-1.3,2.2-2.3c0.5-1,0.8-2.2,0.8-3.5c0-1.3-0.3-2.5-0.8-3.5c-0.5-1-1.3-1.8-2.2-2.3c-0.9-0.5-2-0.8-3.2-0.8 s-2.3,0.3-3.2,0.8c-0.9,0.5-1.7,1.3-2.3,2.3c-0.6,1-0.8,2.2-0.8,3.5c0,1.3,0.3,2.5,0.8,3.5c0.6,1,1.3,1.8,2.3,2.3 C356.6,97,357.7,97.2,358.9,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M380.8,82c1.4,0,2.6,0.3,3.6,0.8c1,0.5,1.9,1.3,2.5,2.4c0.6,1.1,0.9,2.4,0.9,4.1v9.8h-2.3v-9.6 c0-1.8-0.4-3.1-1.3-4s-2.1-1.4-3.8-1.4c-1.2,0-2.3,0.2-3.1,0.7c-0.9,0.5-1.6,1.2-2.1,2.1c-0.5,0.9-0.7,2-0.7,3.3v8.9h-2.3V82.2h2.2 v4.6L374,86c0.5-1.2,1.4-2.2,2.6-2.9C377.8,82.4,379.2,82,380.8,82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M398.5,99.3c-1.4,0-2.7-0.2-4-0.6c-1.2-0.4-2.2-0.9-2.9-1.5l1-1.8c0.7,0.5,1.6,1,2.6,1.3 c1.1,0.4,2.2,0.6,3.4,0.6c1.6,0,2.8-0.3,3.5-0.8c0.7-0.5,1.1-1.2,1.1-2c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.6-0.8 c-0.6-0.2-1.4-0.3-2.2-0.5c-0.8-0.1-1.6-0.3-2.4-0.5s-1.5-0.4-2.1-0.8c-0.6-0.3-1.2-0.8-1.6-1.4c-0.4-0.6-0.6-1.4-0.6-2.3 c0-0.9,0.3-1.8,0.8-2.5c0.5-0.7,1.3-1.3,2.3-1.7c1-0.4,2.2-0.6,3.7-0.6c1.1,0,2.2,0.1,3.3,0.4c1.1,0.3,2,0.7,2.7,1.1l-1,1.8 c-0.8-0.5-1.6-0.9-2.4-1.1c-0.9-0.2-1.7-0.3-2.6-0.3c-1.5,0-2.7,0.3-3.4,0.8c-0.7,0.5-1.1,1.2-1.1,2c0,0.6,0.2,1.2,0.6,1.5 c0.4,0.4,0.9,0.7,1.6,0.9c0.7,0.2,1.4,0.4,2.2,0.5s1.6,0.3,2.4,0.5c0.8,0.2,1.5,0.4,2.2,0.7s1.2,0.8,1.6,1.3 c0.4,0.6,0.6,1.3,0.6,2.2c0,1-0.3,1.8-0.8,2.6c-0.5,0.7-1.3,1.3-2.4,1.7C401.3,99.1,400,99.3,398.5,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M418.7,99.1V76.5h2.4v22.6H418.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M436.6,82c1.4,0,2.6,0.3,3.6,0.8c1,0.5,1.9,1.3,2.5,2.4c0.6,1.1,0.9,2.4,0.9,4.1v9.8h-2.3v-9.6 c0-1.8-0.4-3.1-1.3-4s-2.1-1.4-3.8-1.4c-1.2,0-2.3,0.2-3.1,0.7c-0.9,0.5-1.6,1.2-2.1,2.1c-0.5,0.9-0.7,2-0.7,3.3v8.9h-2.3V82.2h2.2 v4.6l-0.4-0.9c0.5-1.2,1.4-2.2,2.6-2.9C433.5,82.4,434.9,82,436.6,82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M447.1,84.1v-1.9h10.5v1.9H447.1z M455.1,99.3c-1.6,0-2.8-0.4-3.7-1.3c-0.9-0.9-1.3-2.1-1.3-3.6V78.4h2.3 v15.8c0,1,0.3,1.8,0.8,2.3c0.5,0.5,1.2,0.8,2.2,0.8c1,0,1.8-0.3,2.5-0.9l0.8,1.6c-0.5,0.4-1,0.7-1.6,0.9 C456.4,99.2,455.8,99.3,455.1,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M469.4,99.3c-1.8,0-3.3-0.4-4.6-1.1c-1.3-0.7-2.4-1.8-3.1-3.1s-1.1-2.8-1.1-4.5c0-1.7,0.4-3.2,1.1-4.5 c0.7-1.3,1.7-2.3,3-3c1.3-0.7,2.7-1.1,4.2-1.1c1.6,0,3,0.4,4.2,1.1s2.2,1.7,2.9,3c0.7,1.3,1.1,2.8,1.1,4.5c0,0.1,0,0.2,0,0.3 s0,0.2,0,0.4h-14.7v-1.7h13.5l-0.9,0.7c0-1.2-0.3-2.3-0.8-3.3c-0.5-1-1.2-1.7-2.1-2.2c-0.9-0.5-1.9-0.8-3.1-0.8 c-1.2,0-2.2,0.3-3.1,0.8c-0.9,0.5-1.6,1.3-2.2,2.3c-0.5,1-0.8,2.1-0.8,3.3v0.4c0,1.3,0.3,2.4,0.9,3.4c0.6,1,1.4,1.7,2.4,2.3 c1,0.5,2.2,0.8,3.5,0.8c1,0,2-0.2,2.9-0.5c0.9-0.4,1.7-0.9,2.3-1.7l1.3,1.5c-0.8,0.9-1.7,1.6-2.8,2.1C472,99,470.8,99.3,469.4,99.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M481.7,99.1V82.2h2.2v4.6l-0.2-0.8c0.5-1.3,1.3-2.3,2.4-3c1.1-0.7,2.5-1,4.2-1v2.2c-0.1,0-0.2,0-0.3,0 s-0.2,0-0.3,0c-1.8,0-3.2,0.5-4.2,1.6c-1,1.1-1.5,2.6-1.5,4.6v8.6H481.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M501.2,99.3c-1.7,0-3.2-0.4-4.5-1.1c-1.3-0.7-2.4-1.8-3.1-3.1s-1.1-2.8-1.1-4.5c0-1.7,0.4-3.2,1.1-4.5 s1.8-2.3,3.1-3c1.3-0.7,2.8-1.1,4.5-1.1c1.4,0,2.7,0.3,3.9,0.8c1.2,0.6,2.1,1.4,2.7,2.5l-1.7,1.2c-0.6-0.9-1.3-1.5-2.2-1.9 c-0.9-0.4-1.8-0.6-2.8-0.6c-1.2,0-2.3,0.3-3.3,0.8c-1,0.5-1.7,1.3-2.3,2.3c-0.6,1-0.8,2.2-0.8,3.5c0,1.3,0.3,2.5,0.8,3.5 c0.6,1,1.3,1.8,2.3,2.3c1,0.5,2.1,0.8,3.3,0.8c1,0,1.9-0.2,2.8-0.6c0.9-0.4,1.6-1,2.2-1.9l1.7,1.2c-0.7,1.1-1.6,1.9-2.7,2.5 C504,99,502.7,99.3,501.2,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M519.3,99.3c-1.8,0-3.3-0.4-4.6-1.1c-1.3-0.7-2.4-1.8-3.1-3.1c-0.8-1.3-1.1-2.8-1.1-4.5 c0-1.7,0.4-3.2,1.1-4.5c0.7-1.3,1.7-2.3,3-3c1.3-0.7,2.7-1.1,4.2-1.1c1.6,0,3,0.4,4.2,1.1s2.2,1.7,2.9,3c0.7,1.3,1.1,2.8,1.1,4.5 c0,0.1,0,0.2,0,0.3s0,0.2,0,0.4h-14.7v-1.7h13.5l-0.9,0.7c0-1.2-0.3-2.3-0.8-3.3c-0.5-1-1.2-1.7-2.1-2.2c-0.9-0.5-1.9-0.8-3.1-0.8 c-1.2,0-2.2,0.3-3.1,0.8c-0.9,0.5-1.6,1.3-2.2,2.3c-0.5,1-0.8,2.1-0.8,3.3v0.4c0,1.3,0.3,2.4,0.9,3.4c0.6,1,1.4,1.7,2.4,2.3 c1,0.5,2.2,0.8,3.5,0.8c1,0,2-0.2,2.9-0.5c0.9-0.4,1.7-0.9,2.3-1.7l1.3,1.5c-0.8,0.9-1.7,1.6-2.8,2.1 C521.9,99,520.6,99.3,519.3,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M531.6,105.4V82.2h2.2v5.1l-0.2,3.4l0.3,3.4v11.3H531.6z M540.3,99.3c-1.5,0-2.8-0.3-4-1 c-1.2-0.7-2.1-1.7-2.8-2.9c-0.7-1.3-1-2.8-1-4.7c0-1.8,0.3-3.4,1-4.7c0.7-1.3,1.6-2.3,2.8-2.9c1.2-0.7,2.5-1,4-1 c1.6,0,3.1,0.4,4.3,1.1s2.3,1.7,3,3c0.7,1.3,1.1,2.8,1.1,4.5c0,1.7-0.4,3.2-1.1,4.5c-0.7,1.3-1.7,2.3-3,3 C543.4,98.9,541.9,99.3,540.3,99.3z M540.1,97.2c1.2,0,2.3-0.3,3.2-0.8c0.9-0.5,1.7-1.3,2.3-2.3c0.6-1,0.8-2.2,0.8-3.5 c0-1.3-0.3-2.5-0.8-3.5c-0.6-1-1.3-1.8-2.3-2.3c-0.9-0.6-2-0.8-3.2-0.8c-1.2,0-2.3,0.3-3.2,0.8c-1,0.6-1.7,1.3-2.3,2.3 c-0.5,1-0.8,2.1-0.8,3.5c0,1.3,0.3,2.5,0.8,3.5c0.5,1,1.3,1.8,2.3,2.3C537.9,97,538.9,97.2,540.1,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M550.8,84.1v-1.9h10.5v1.9H550.8z M558.8,99.3c-1.6,0-2.8-0.4-3.7-1.3c-0.9-0.9-1.3-2.1-1.3-3.6V78.4h2.3 v15.8c0,1,0.3,1.8,0.8,2.3c0.5,0.5,1.2,0.8,2.2,0.8c1,0,1.8-0.3,2.5-0.9l0.8,1.6c-0.5,0.4-1,0.7-1.6,0.9 C560.1,99.2,559.5,99.3,558.8,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M573.1,99.3c-1.8,0-3.3-0.4-4.6-1.1c-1.3-0.7-2.4-1.8-3.1-3.1s-1.1-2.8-1.1-4.5c0-1.7,0.4-3.2,1.1-4.5 c0.7-1.3,1.7-2.3,3-3c1.3-0.7,2.7-1.1,4.2-1.1c1.6,0,3,0.4,4.2,1.1s2.2,1.7,2.9,3c0.7,1.3,1.1,2.8,1.1,4.5c0,0.1,0,0.2,0,0.3 s0,0.2,0,0.4h-14.7v-1.7h13.5l-0.9,0.7c0-1.2-0.3-2.3-0.8-3.3c-0.5-1-1.2-1.7-2.1-2.2c-0.9-0.5-1.9-0.8-3.1-0.8 c-1.2,0-2.2,0.3-3.1,0.8c-0.9,0.5-1.6,1.3-2.2,2.3c-0.5,1-0.8,2.1-0.8,3.3v0.4c0,1.3,0.3,2.4,0.9,3.4c0.6,1,1.4,1.7,2.4,2.3 c1,0.5,2.2,0.8,3.5,0.8c1,0,2-0.2,2.9-0.5c0.9-0.4,1.7-0.9,2.3-1.7l1.3,1.5c-0.8,0.9-1.7,1.6-2.8,2.1 C575.7,99,574.5,99.3,573.1,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M592.1,99.3c-1.6,0-3.1-0.4-4.3-1.1c-1.3-0.7-2.3-1.7-3-3c-0.7-1.3-1.1-2.8-1.1-4.5c0-1.7,0.4-3.2,1.1-4.5 c0.7-1.3,1.7-2.3,3-3c1.3-0.7,2.7-1.1,4.3-1.1c1.5,0,2.8,0.3,4,1c1.2,0.7,2.1,1.6,2.8,2.9c0.7,1.3,1,2.8,1,4.7c0,1.8-0.3,3.4-1,4.7 c-0.7,1.3-1.6,2.3-2.8,3C595,98.9,593.6,99.3,592.1,99.3z M592.3,97.2c1.2,0,2.3-0.3,3.2-0.8c1-0.5,1.7-1.3,2.3-2.3 c0.5-1,0.8-2.2,0.8-3.5c0-1.3-0.3-2.5-0.8-3.5c-0.5-1-1.3-1.8-2.3-2.3c-1-0.5-2-0.8-3.2-0.8c-1.2,0-2.2,0.3-3.2,0.8 c-0.9,0.5-1.7,1.3-2.3,2.3c-0.6,1-0.8,2.2-0.8,3.5c0,1.3,0.3,2.5,0.8,3.5s1.3,1.8,2.3,2.3C590.1,97,591.1,97.2,592.3,97.2z  M598.7,99.1V94l0.2-3.4l-0.3-3.4v-12h2.3v23.9H598.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M607.5,99.3c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.8-0.5-1.3c0-0.5,0.2-0.9,0.5-1.3c0.3-0.3,0.7-0.5,1.2-0.5 s0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.7,0.5,1.3c0,0.5-0.2,0.9-0.5,1.3C608.4,99.1,608,99.3,607.5,99.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntruceptLightLogo);
export default __webpack_public_path__ + "static/media/intrucept-light-logo.c904746dc6a315711d4a5296b438aeb0.svg";
export { ForwardRef as ReactComponent };